<template>
  <a-modal
    :title="isAdd ? '新建学期' : '修改学期'"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 学期名称 -->
      <a-form-item
        label="学期名称"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          v-decorator="[
            'termName',
            {
              rules: [
                {
                  required: true,
                  pattern: /^.{2,10}$/,
                  message: '请输入长度为2~10位的学期名称',
                },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>

      <!-- 开班结班时间 -->
      <a-form-item
        label="开班结班时间"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-range-picker
          class="picker"
          :defaultValue="
            continuedTimeObj
              ? [
                  moment(continuedTimeObj.startTime, dateFormat),
                  moment(continuedTimeObj.endTime, dateFormat),
                ]
              : null
          "
          v-decorator="[
            'continuedTime',
            { rules: [{ required: true, message: '请选择' }] },
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import term from "../../api/term";

import { getDateDay } from "../../utils/date";

import moment from "moment";

export default {
  name: "termFormModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      termId: "",
      updateData: {},

      dateFormat: "YYYY-MM-DD HH:mm:ss",
      continuedTimeObj: null,
    };
  },
  methods: {
    moment,
    //初始化，显示
    init(type, params) {
      this.visible = true;
      this.isAdd = type === "add" ? true : false;
      //初始化form表单数据
      if (params) {
        this.updateData = params;
        let formData = {};
        formData.termName = params.termName;
        formData.continuedTime = [
          moment(new Date(params.startDate)),
          moment(new Date(params.endDate)),
        ];
        this.continuedTimeObj = {
          startTime: params.startDate,
          endTime: params.endDate,
        };

        //记录当前学期的ID
        this.termId = params.id;
        setTimeout(() => {
          this.form.setFieldsValue(formData);
        }, 100);
      } else {
        this.continuedTimeObj = null;
        setTimeout(() => {
          this.form.resetFields();
        }, 1);
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, value) => {
        console.log("输入的内容是：", value);
        //校验通过
        if (!err) {
          //处理开班/接班起止日期
          (value.startDate = getDateDay(value.continuedTime[0])),
            (value.endDate = getDateDay(value.continuedTime[1])),
            delete value.continuedTime;

          if (this.isAdd) {
            this.addTerm(value);
          } else {
            this.updateTerm(value);
          }
        }
      });
    },

    //新增学期
    addTerm(value) {
      term.addTerm(value).then((res) => {
        this.$message.success("新增成功");
        this.handleCancel();
        this.$emit("addTerm", res.data);
      });
    },

    //修改学期
    updateTerm(value) {
      term.updateTerm(this.termId, value).then((res) => {
        this.$message.success("修改成功");
        this.handleCancel();
        Object.assign(this.updateData, value);
        this.$emit("updateTerm", res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";

.person-scope {
  width: 100px;
  text-align: center;
  display: inline-block;
}
.max-person {
  border-left: none;
}
.person-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
</style>